var _use, _ellipse, _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 540 540",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  }, props), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 17.18,
    y: 17.47,
    width: 506.2,
    height: 504.64,
    transform: "scale(.99841 .9993)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.93,
    cy: 292.11,
    rx: 208.09,
    ry: 188.17,
    fill: "#efeeda",
    stroke: "#efeeda",
    strokeWidth: 0.8,
    transform: "matrix(1.18507 0 0 1.30639 -91.1 -111.83)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.18 121c0 .9.04 1.75.12 2.6.04.85.23 1.62.58 2.28.3.7.81 1.24 1.5 1.67.66.42 1.63.61 2.83.61 1.82 0 3.1-.5 3.83-1.54.73-1.05 1.08-2.52 1.08-4.49v-20.15h2.63v20.23c0 2.7-.62 4.75-1.9 6.19-1.27 1.47-3.24 2.16-5.95 2.16a7.66 7.66 0 01-3.79-.81 5.32 5.32 0 01-2.2-2.13 8.44 8.44 0 01-1.09-3.05c-.19-1.12-.27-2.32-.27-3.56h2.63zM208.4 109.8h2.32v20.03h-2.32v-2.79c-.31.35-.66.74-1.04 1.12a7.1 7.1 0 01-1.32 1.05c-.5.35-1.12.62-1.78.85-.66.2-1.43.3-2.32.3-1.35 0-2.47-.19-3.36-.57a5.28 5.28 0 01-2.17-1.55 5.7 5.7 0 01-1.2-2.36 9.93 9.93 0 01-.39-2.9V109.8h2.33v13.15c0 1.74.38 3.06 1.2 3.95.8.93 2.12 1.39 3.94 1.39.97 0 1.82-.2 2.59-.58.74-.35 1.4-.89 1.9-1.55.5-.65.92-1.47 1.2-2.4.26-.92.42-1.93.42-3.05v-10.9zM231.8 119.73c0-1.12-.16-2.2-.47-3.25-.3-1-.77-1.9-1.31-2.66a7.39 7.39 0 00-2.13-1.82 6.36 6.36 0 00-2.86-.66c-1.2 0-2.24.23-3.13.7a6.63 6.63 0 00-2.17 1.97 8.35 8.35 0 00-1.24 2.86 13.27 13.27 0 00-.3 3.56c0 1.28.19 2.36.54 3.32a6.44 6.44 0 003.6 3.98 6.9 6.9 0 005.6-.1 6 6 0 002.13-1.83c.58-.73 1-1.66 1.31-2.7.27-1.05.43-2.17.43-3.37zm0-17.75h2.32v27.85h-2.32v-3.52h-.08a6.53 6.53 0 01-1.28 1.74c-.54.5-1.12.93-1.74 1.27-.65.35-1.31.58-1.97.78a9.51 9.51 0 01-6.11-.54 7.53 7.53 0 01-2.78-2.25 9.22 9.22 0 01-1.63-3.32c-.35-1.28-.5-2.67-.5-4.14 0-1.4.2-2.75.54-4.02a9.98 9.98 0 011.66-3.4 8.6 8.6 0 012.79-2.33 8.47 8.47 0 013.94-.85c1.43 0 2.79.31 4.1.93a7.42 7.42 0 013.06 2.82v-11.02zM240.3 129.83v-20.04h2.33v20.04h-2.32zm-.1-24.4v-3.45h2.54v3.44h-2.55zM255.58 129.9c-.27.04-.65.16-1.12.27-.46.12-.96.2-1.55.2-1.16 0-2.04-.27-2.62-.9-.62-.57-.93-1.58-.93-3.09v-14.65h-2.83v-1.94h2.83v-5.57h2.32v5.57h3.75v1.94h-3.75v13.73c0 .5 0 .92.04 1.27.03.35.11.66.23.9.11.22.35.38.62.5.27.11.62.15 1.12.15.3 0 .62-.04.97-.08.3-.04.61-.11.92-.2v1.9zM259.3 129.83v-27.85h2.32v10.6c.92-.97 1.9-1.78 2.9-2.4a6.5 6.5 0 013.55-.93c1.24 0 2.4.2 3.45.62a6.14 6.14 0 013.56 4.45c.07.77.11 1.58.11 2.4v13.1h-2.32v-13.07c0-1.81-.39-3.17-1.2-4.06-.81-.89-2.13-1.35-3.98-1.35-.74 0-1.4.12-1.97.31a7 7 0 00-1.59.89 5.96 5.96 0 00-2.01 2.7 7.08 7.08 0 00-.43 1.86 28.8 28.8 0 00-.07 1.94v10.79h-2.32zM291.94 101.98h2.63v16.6c0 3.43.65 5.95 1.93 7.46 1.28 1.5 3.37 2.28 6.23 2.28 1.5 0 2.74-.2 3.83-.62 1.04-.39 1.85-1 2.51-1.82a7.25 7.25 0 001.4-3.01c.26-1.2.42-2.63.42-4.3v-16.59h2.63v17.37c0 3.63-.9 6.42-2.67 8.31-1.82 1.93-4.53 2.9-8.12 2.9-3.64 0-6.34-.97-8.12-2.94-1.78-1.97-2.67-4.72-2.67-8.27v-17.37zM326.51 129.9c-.27.04-.65.16-1.12.27-.46.12-.96.2-1.55.2-1.16 0-2.04-.27-2.62-.9-.62-.57-.93-1.58-.93-3.09v-14.65h-2.83v-1.94h2.83v-5.57h2.32v5.57h3.75v1.94h-3.75v13.73c0 .5 0 .92.04 1.27.03.35.11.66.23.9.11.22.35.38.62.5.27.11.62.15 1.12.15.3 0 .62-.04.97-.08.3-.04.61-.11.92-.2v1.9zM337.26 129.9c-.27.04-.65.16-1.12.27-.46.12-.96.2-1.54.2-1.16 0-2.05-.27-2.63-.9-.62-.57-.93-1.58-.93-3.09v-14.65h-2.83v-1.94h2.83v-5.57h2.32v5.57h3.75v1.94h-3.75v13.73c0 .5 0 .92.04 1.27s.11.66.23.9c.12.22.35.38.62.5.27.11.62.15 1.12.15.3 0 .62-.04.97-.08.3-.04.62-.11.92-.2v1.9zM355.48 118.42c0-.97-.12-1.9-.39-2.79a7.34 7.34 0 00-1.2-2.24 6.11 6.11 0 00-2-1.5 6.82 6.82 0 00-2.75-.55 5.94 5.94 0 00-4.72 2.13c-.58.65-1 1.39-1.35 2.24-.35.85-.55 1.74-.66 2.7h13.07zm-13.07 1.93c0 1.08.15 2.09.42 3.06.27 1 .7 1.81 1.28 2.51a5.29 5.29 0 002.09 1.7c.85.43 1.82.66 2.94.66 1.5 0 2.82-.39 3.9-1.2a5.75 5.75 0 002.17-3.4h2.6c-.28.96-.67 1.82-1.13 2.63a7.77 7.77 0 01-4.22 3.56 9.7 9.7 0 01-3.32.5 9.75 9.75 0 01-4.14-.81 7.49 7.49 0 01-2.86-2.25 9.28 9.28 0 01-1.67-3.32 15.45 15.45 0 01-.54-4.1c0-1.47.2-2.86.66-4.14a9.22 9.22 0 014.68-5.69 8.87 8.87 0 013.87-.8c2.74 0 4.91.96 6.5 2.82 1.58 1.93 2.35 4.67 2.32 8.27H342.4zM364.92 129.83h-2.32v-20.04h2.32v3.75h.07c.66-1.58 1.47-2.7 2.52-3.36 1-.62 2.36-.93 4.02-.93v2.52c-1.31-.04-2.4.19-3.25.61a5.28 5.28 0 00-2 1.78c-.51.74-.86 1.63-1.05 2.63-.2 1.05-.31 2.1-.31 3.21v9.83z",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M313.44 232.53c2.5-24.18 8.2-50.36 8.2-50.36a2.16 2.16 0 014.25.83s-6.84 38.14-8.12 64.55c-.37 7.75-.44 14.45.66 18.82.33 1.28.7 2.34 1.26 3.08.41.56.91.91 1.59.8 5.19-.8 9.15-5.16 12.26-10.39 6.28-10.55 8.98-24.75 9.2-25.38a.94.94 0 011.8.56c-.2.65-2.23 15.32-8.12 26.44-3.42 6.46-8.22 11.63-14.4 12.88-2.88.58-5.14-.74-6.76-3.75-1.64-3.05-2.6-8.35-2.88-14.91-.9 3.88-2.08 8.6-3.43 13.37-1.3 4.64-2.68 9.35-4.47 13.3-1.8 4.02-3.99 7.27-6.4 9.21a9.43 9.43 0 01-5.35 2.16c-4.5.23-7.17-2.53-8.27-7.27-2.1-9 2.56-26.68 3.38-34.93 1.22-12.05 4.65-30.47 1.42-43.9-2.18-9.06-7.57-15.7-19.3-15.83-3.12-.04-6.08.36-8.89 1.13l-.02.06-.89 3.37c-1.94 7.4-6.2 24.08-7.45 33.74-.92 6.94-1.67 14.73-2.52 23.25l-.76 7.38a13.3 13.3 0 003.2-1.4c7.58-4.54 14.47-17.04 14.83-41.8.03-1.7-.02-3.45-.08-5.25-.1-2.84 1.23-2.46 1.6-1.03.12.47.26 1.33.39 2.52.71 6.55 1.04 23.2-5.18 36.44a36.54 36.54 0 01-5.37 8.4v.01l-.03.02-.09.1-.05.06a28.2 28.2 0 01-9.76 7.25l-.26 2.82a847.03 847.03 0 00-1.95 25.93 571.6 571.6 0 01-.8 11.43 158.07 158.07 0 0015.3-14.01c8.63-9.2 9.07-13.2 9.07-13.2a.69.69 0 011.37.1s-.26 4.34-9.2 14.24c-3.79 4.2-9.17 9.43-16.8 15.79-1.6 18.54-3.94 32.71-7.01 42.54-1.97 6.3-4.26 10.87-6.81 13.76-3.08 3.47-6.56 4.7-10.4 3.82-8.6-1.99-10.17-9.75-7.14-19.62 4.14-13.48 16.75-30.95 27.06-39.74.38-4.81.7-9.93.97-15.35.48-9.42 1.08-18.4 1.79-26.83l-.44.1c-6.45 1.57-11.43-.19-15.02-3.74-5.08-5.03-7.31-13.81-6.78-22.04.54-8.7 7.25-28.16 20.06-41.1 7.38-7.44 16.75-12.7 28.07-12.76 13.95-.06 20.5 7.72 23.26 18.45 3.56 13.81.46 32.87-.59 45.34-.59 6.83-3.84 20.34-3.5 29.56.08 2.1.37 3.94.96 5.35.47 1.15 1.18 1.98 2.5 1.99 1.8.02 3.42-1.12 4.97-2.85 2.13-2.38 4.06-5.77 5.76-9.58a76.73 76.73 0 003.18-8.12c2.56-8.05 3.83-16.2 4.43-19.99l2.5-15.82zm-72.38 80.6c-7.89 7.55-16.7 19.87-21.5 30.94-2.06 4.75-3.37 9.27-3.5 13.05-.14 4.47 1.53 7.8 6.1 8.77 2.6.56 4.88-.44 6.92-2.8 2.27-2.63 4.21-6.8 5.92-12.5 2.67-8.89 4.68-21.37 6.06-37.46zm16.42-118.98a41.43 41.43 0 00-13.4 9.01c-12.47 12.2-19.21 30.73-19.86 39.07-.56 7.56 1.3 15.68 5.92 20.35 3.09 3.13 7.42 4.64 13.04 3.34.37-.08.72-.17 1.08-.27l.06-.66c-8.8-1-16.23-9.72-15.13-20.7.91-9.08 3.5-16.1 7.97-23.45 4.64-7.6 11.33-15.58 20.32-26.69zm.17 3.13c-7.95 10.23-13.94 17.77-18.13 24.97-4.09 7.04-6.4 13.73-7.08 22.34-.7 8.85 5.17 15.8 12.22 16.57l.57-5.71c.19-1.77.37-3.5.58-5.2.95-7.55 2.11-14.47 3.22-20.7 1.61-9.1 6.16-24.3 8.62-32.27z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M269.85 62.86c114.27 0 207.05 92.58 207.05 206.6s-92.78 206.6-207.05 206.6c-114.27 0-207.05-92.58-207.05-206.6s92.78-206.6 207.05-206.6zm0 0c114.27 0 207.05 92.58 207.05 206.6s-92.78 206.6-207.05 206.6c-114.27 0-207.05-92.58-207.05-206.6s92.78-206.6 207.05-206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.52 61.64a207.84 207.84 0 01146.49 60.82c37.74 37.62 61.1 89.6 61.1 147 0 57.39-23.36 109.37-61.1 147a207.84 207.84 0 01-146.49 60.81h-.67a207.83 207.83 0 01-147.16-60.81c-37.74-37.63-61.1-89.61-61.1-147 0-57.4 23.36-109.38 61.1-147a207.83 207.83 0 01147.16-60.82h.67zm-.67 2.44a205.42 205.42 0 00-145.44 60.1c-37.3 37.19-60.39 88.56-60.39 145.28 0 56.71 23.09 108.09 60.4 145.27a205.42 205.42 0 00145.43 60.1h.66a205.41 205.41 0 00144.77-60.1c37.3-37.18 60.4-88.56 60.4-145.27 0-56.72-23.1-108.1-60.4-145.28a205.41 205.41 0 00-144.77-60.1h-.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.94 276v-23.05h3.33l7.55 20.32h.06l7.43-20.32h3.3v23.04h-2.18v-20.55h-.06L422.8 276h-2.05l-7.58-20.55h-.07V276h-2.17zM450.21 267.64c0-.93-.13-1.82-.38-2.69a7.9 7.9 0 00-1.09-2.2 6.11 6.11 0 00-1.76-1.51c-.7-.35-1.5-.55-2.37-.55-1 0-1.86.2-2.6.58-.73.42-1.3.96-1.78 1.63a6.9 6.9 0 00-1.03 2.37c-.22.93-.29 1.89-.25 2.95a8 8 0 00.44 2.75 5.33 5.33 0 002.98 3.3 5.71 5.71 0 004.64-.1c.7-.35 1.28-.86 1.76-1.5.48-.61.83-1.38 1.09-2.25.22-.86.35-1.79.35-2.78zm0-14.7h1.92V276h-1.92v-2.9h-.06a5.4 5.4 0 01-1.06 1.43c-.45.42-.93.77-1.44 1.06-.54.29-1.09.48-1.63.64a7.87 7.87 0 01-5.06-.45 6.23 6.23 0 01-2.3-1.86 7.63 7.63 0 01-1.35-2.75 13.04 13.04 0 01.03-6.75 8.26 8.26 0 011.38-2.82 7.12 7.12 0 012.3-1.92c.93-.48 2.02-.7 3.27-.7 1.18 0 2.3.25 3.4.76a6.14 6.14 0 012.52 2.34v-9.12z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.27 281.47v-23.05H95.6v1.86H82.45v8.32h11.87v1.86H82.45v9.15h13.47v1.86H80.27zM112.34 273.11c0-.92-.12-1.82-.38-2.69a7.9 7.9 0 00-1.09-2.2 6.11 6.11 0 00-1.76-1.5c-.7-.36-1.5-.55-2.37-.55-.99 0-1.85.19-2.59.57-.74.42-1.31.96-1.8 1.64a6.9 6.9 0 00-1.02 2.36c-.22.93-.28 1.9-.25 2.95a8 8 0 00.45 2.75 5.33 5.33 0 002.98 3.3 5.71 5.71 0 004.63-.1c.7-.35 1.28-.86 1.76-1.5.48-.6.84-1.38 1.1-2.24.22-.87.34-1.8.34-2.79zm0-14.69h1.92v23.05h-1.92v-2.92h-.06a5.4 5.4 0 01-1.06 1.45c-.44.41-.92.76-1.44 1.05-.54.29-1.08.48-1.63.64a7.87 7.87 0 01-5.06-.45 6.23 6.23 0 01-2.3-1.85 7.63 7.63 0 01-1.35-2.76 13.04 13.04 0 01.04-6.75 8.26 8.26 0 011.37-2.82 7.12 7.12 0 012.3-1.92c.94-.48 2.02-.7 3.27-.7 1.19 0 2.3.26 3.4.77a6.14 6.14 0 012.52 2.33v-9.12zM131.1 272.03c0-.8-.1-1.57-.32-2.3a6.08 6.08 0 00-1-1.87c-.44-.5-.98-.92-1.66-1.24a5.64 5.64 0 00-2.27-.45 4.92 4.92 0 00-3.9 1.76 6.39 6.39 0 00-1.12 1.85 8.5 8.5 0 00-.55 2.25h10.82zm-10.82 1.6c0 .9.13 1.72.35 2.52.23.84.58 1.5 1.06 2.08.45.61 1.02 1.1 1.73 1.41.7.36 1.5.55 2.43.55 1.25 0 2.34-.32 3.23-1 .9-.67 1.5-1.6 1.8-2.81h2.14c-.22.8-.54 1.5-.93 2.17a6.43 6.43 0 01-3.49 2.95c-.8.29-1.7.42-2.75.42a8.07 8.07 0 01-3.42-.68 6.2 6.2 0 01-2.37-1.85 7.68 7.68 0 01-1.38-2.76 12.78 12.78 0 01-.45-3.39c0-1.21.16-2.37.55-3.42a7.63 7.63 0 013.87-4.7 7.34 7.34 0 013.2-.68c2.27 0 4.07.8 5.38 2.34 1.31 1.6 1.95 3.87 1.92 6.85h-12.87zM138.82 281.47h-1.92v-16.58h1.92v2.3c.76-.8 1.56-1.47 2.4-1.98.8-.51 1.79-.77 2.94-.77 1.03 0 1.99.16 2.85.51a5.08 5.08 0 012.94 3.68c.07.64.1 1.31.1 1.99v10.85h-1.92v-10.82c0-1.5-.32-2.63-1-3.36-.66-.74-1.75-1.12-3.29-1.12-.6 0-1.15.1-1.63.25-.48.2-.93.45-1.31.74-.42.29-.74.64-1.03 1.02a5.86 5.86 0 00-1 2.75c-.02.49-.05 1.03-.05 1.6v8.94z",
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.54 378.94h-.07v21.77h-2.35v-24.96h2.67l14.42 21.8h.07v-21.8h2.35v24.96h-2.73l-14.36-21.77z",
    fill: "url(#_Linear2)",
    fillRule: "nonzero",
    transform: "rotate(43.68 125.38 400.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.27 408.72c-.88.37-1.77.61-2.67.73-.9.11-1.8.2-2.7.28-1.6.11-2.84.47-3.73 1.07-.89.6-1.33 1.51-1.33 2.74a2.97 2.97 0 001.2 2.44c.35.27.77.46 1.24.6.48.12.96.18 1.44.18.83 0 1.64-.1 2.43-.3.78-.22 1.48-.53 2.1-.96a4.7 4.7 0 002.03-3.97v-2.81zm-3.5-1.04l1.4-.2c.55-.1 1-.23 1.34-.39.35-.16.56-.43.64-.81.08-.38.12-.74.12-1.06 0-1.06-.34-1.94-1.02-2.62-.68-.68-1.83-1.02-3.45-1.02a9.5 9.5 0 00-1.98.19 4.3 4.3 0 00-1.57.66c-.45.31-.82.73-1.11 1.25a5.29 5.29 0 00-.57 1.95h-2.12c.07-1.06.31-1.96.73-2.72.42-.75.95-1.36 1.61-1.83a6.7 6.7 0 012.29-1.04 11.21 11.21 0 015.3-.04c.8.2 1.5.51 2.08.94.6.43 1.05 1 1.4 1.71.33.72.5 1.6.5 2.64v9.77c0 .81.14 1.33.43 1.55.28.22.87.16 1.75-.16v1.63l-.71.2c-.32.1-.62.15-.92.15-.33 0-.64-.04-.94-.1a1.6 1.6 0 01-.83-.34c-.2-.17-.38-.38-.5-.62-.13-.24-.22-.5-.26-.8-.05-.29-.07-.6-.07-.92a8.86 8.86 0 01-8.96 2.67 5.5 5.5 0 01-1.93-.97c-.55-.44-1-.97-1.31-1.61a4.95 4.95 0 01-.49-2.27c0-3.05 2.1-4.85 6.28-5.4l2.87-.39z",
    fill: "url(#_Linear3)",
    fillRule: "nonzero",
    transform: "rotate(34 144.03 418.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.38 429.07c-.26.04-.6.13-1.01.24-.42.12-.88.17-1.39.17-1.04 0-1.83-.26-2.37-.78-.55-.52-.82-1.45-.82-2.79v-13.14h-2.53v-1.73h2.53v-5h2.08v5h3.37v1.73h-3.37v12.31c0 .44.01.82.04 1.15.02.32.09.58.2.8.12.2.3.35.54.44a3 3 0 001.03.14c.27 0 .56-.02.84-.07.3-.04.58-.1.85-.17v1.7z",
    fill: "url(#_Linear4)",
    fillRule: "nonzero",
    transform: "rotate(28.25 160.57 429)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.03 415.99h2.08v17.95h-2.08v-2.5c-.28.33-.6.67-.94 1.01a7.1 7.1 0 01-2.77 1.69c-.6.2-1.3.29-2.08.29-1.2 0-2.2-.17-3.02-.5-.8-.34-1.46-.8-1.96-1.4-.5-.6-.85-1.3-1.07-2.1a9.82 9.82 0 01-.33-2.62v-11.82h2.08v11.78c0 1.55.36 2.74 1.07 3.56.72.82 1.9 1.23 3.54 1.23a4.81 4.81 0 004.02-1.9c.47-.61.82-1.33 1.08-2.16.25-.83.38-1.74.38-2.74V416z",
    fill: "url(#_Linear5)",
    fillRule: "nonzero",
    transform: "rotate(22.78 169.36 433.94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.36 441.43h-2.08v-17.95h2.08v3.36h.07a6.01 6.01 0 012.24-3 6.8 6.8 0 013.62-.85v2.25a6.07 6.07 0 00-2.91.56 4.8 4.8 0 00-1.82 1.6 6.34 6.34 0 00-.94 2.37c-.17.91-.26 1.86-.26 2.86v8.8z",
    fill: "url(#_Linear6)",
    fillRule: "nonzero",
    transform: "rotate(17.29 187.68 441.43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.37 435.74c-.88.37-1.77.6-2.67.72-.9.12-1.8.21-2.7.28-1.6.12-2.84.48-3.74 1.08-.88.6-1.33 1.51-1.33 2.74a2.97 2.97 0 001.2 2.44c.36.26.77.46 1.25.59.47.13.95.19 1.43.19.84 0 1.64-.1 2.43-.31.79-.21 1.48-.53 2.1-.96a4.71 4.71 0 002.03-3.97v-2.8zm-3.5-1.04l1.4-.21c.54-.1.99-.22 1.33-.38.35-.16.56-.44.64-.82.08-.38.13-.73.13-1.06 0-1.06-.35-1.93-1.03-2.61-.68-.68-1.83-1.02-3.45-1.02-.71 0-1.37.06-1.97.19a4.3 4.3 0 00-1.58.65c-.45.32-.82.73-1.1 1.25a5.29 5.29 0 00-.58 1.96h-2.12c.07-1.06.32-1.97.73-2.72.42-.75.95-1.36 1.61-1.84a6.67 6.67 0 012.3-1.04 11.17 11.17 0 015.3-.03c.8.2 1.49.5 2.08.93.59.43 1.05 1 1.38 1.72.34.72.5 1.6.5 2.63v9.78c0 .81.15 1.32.44 1.54.29.22.87.17 1.75-.15v1.63l-.71.2c-.31.1-.62.14-.92.14a4.1 4.1 0 01-.94-.1 1.6 1.6 0 01-.83-.33c-.2-.17-.37-.38-.5-.62-.13-.25-.21-.51-.26-.8-.05-.29-.07-.6-.07-.92a8.87 8.87 0 01-8.96 2.67 5.49 5.49 0 01-1.93-.97c-.55-.44-.99-.98-1.31-1.61a4.96 4.96 0 01-.49-2.27c0-3.06 2.1-4.86 6.28-5.41l2.87-.38z",
    fill: "url(#_Linear7)",
    fillRule: "nonzero",
    transform: "rotate(12.87 199.12 445.16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#_Linear8)",
    fillRule: "nonzero",
    d: "M221.28 424.44h2.08v24.96h-2.08z",
    transform: "rotate(9.46 218.47 449.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.7 452.18l9.82-24.96h2.67l9.57 24.96h-2.43l-2.88-7.84h-11.37l-2.94 7.84h-2.43zm6.18-9.85h9.78l-4.9-13.1-4.88 13.1z",
    fill: "url(#_Linear9)",
    fillRule: "nonzero",
    transform: "rotate(4.13 236.19 452.18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.4 453.71h-2.09v-17.95h2.08v3.36h.07a6.02 6.02 0 012.24-3 6.81 6.81 0 013.62-.85v2.25a6.07 6.07 0 00-2.91.56c-.77.4-1.37.92-1.82 1.6a6.31 6.31 0 00-.94 2.37c-.17.91-.26 1.86-.26 2.86v8.8z",
    fill: "url(#_Linear10)",
    fillRule: "nonzero",
    transform: "rotate(1.05 259.71 453.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.6 454c-.26.04-.6.12-1.01.23-.42.12-.88.18-1.4.18-1.03 0-1.82-.26-2.37-.78-.54-.52-.81-1.45-.81-2.8V437.7h-2.53v-1.74H275v-4.99h2.08v5h3.36v1.73h-3.36V450c0 .44.01.83.03 1.15.03.32.1.59.21.8.12.2.3.36.54.45.24.09.58.14 1.02.14.28 0 .56-.03.85-.07.3-.05.57-.1.85-.18v1.7z",
    fill: "url(#_Linear11)",
    fillRule: "nonzero",
    transform: "rotate(-.4 271.79 453.92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.3 440.66c-.69.32-1.33.71-1.92 1.16-.59.45-1.1.95-1.52 1.5a7.4 7.4 0 00-1.03 1.8 5.51 5.51 0 00.05 4.2 5.02 5.02 0 002.95 2.75c.69.25 1.43.38 2.24.38a6.8 6.8 0 003.55-.92 10.92 10.92 0 002.8-2.41l-7.11-8.46zm4.48-5.72c.2-.46.3-.95.26-1.47a3.03 3.03 0 00-1.55-2.48 3.74 3.74 0 00-3.97.38 2.81 2.81 0 00-1.02 2.18c0 .37.1.78.28 1.22.19.44.41.86.68 1.28.26.41.55.81.85 1.2l.8.98c.69-.41 1.39-.87 2.1-1.37.7-.5 1.22-1.13 1.57-1.92zm3.81 12.27c.44-.74.72-1.52.85-2.34.13-.82.2-1.66.2-2.51h2.04a19.7 19.7 0 01-.44 3.38 9.44 9.44 0 01-1.3 3.13l4.06 4.79h-2.8l-2.44-2.95a9.88 9.88 0 01-3.5 2.78 10.67 10.67 0 01-7.41.3 7.6 7.6 0 01-2.48-1.52 6.99 6.99 0 01-1.67-2.34 7.42 7.42 0 011.18-7.75 9.53 9.53 0 011.89-1.71c.72-.5 1.48-.93 2.29-1.3a19.63 19.63 0 01-1.84-2.55 5.73 5.73 0 01-.83-3.03 4.56 4.56 0 011.66-3.64c.51-.42 1.1-.73 1.79-.94.68-.2 1.4-.31 2.17-.31.76 0 1.46.13 2.1.38.66.25 1.21.6 1.67 1.04a4.63 4.63 0 011.46 3.4c0 .83-.13 1.55-.4 2.17a5.55 5.55 0 01-1.07 1.62c-.45.48-.98.91-1.58 1.3-.6.4-1.23.79-1.87 1.18l6.27 7.42z",
    fill: "url(#_Linear12)",
    fillRule: "nonzero",
    transform: "rotate(-6.64 291.67 453.66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.56 449.2v-24.97h8.53c.7 0 1.38.02 2.05.06.67.03 1.33.11 1.97.24a8.86 8.86 0 013.67 1.58 7.6 7.6 0 012.05 2.2c.53.86.96 1.78 1.27 2.74.31.95.53 1.93.66 2.9a21.32 21.32 0 01.03 5.26c-.1.85-.27 1.7-.5 2.51-.23.82-.54 1.6-.92 2.36a9.04 9.04 0 01-3.33 3.62c-.68.4-1.4.7-2.15.92-.75.22-1.53.37-2.34.45a25 25 0 01-2.46.12h-8.53zm2.36-2.02h5.65c1.06 0 2.06-.06 3-.19a8.7 8.7 0 002.86-.95 5.64 5.64 0 002.05-1.7c.53-.72.95-1.5 1.26-2.34.31-.84.53-1.73.66-2.65a19.64 19.64 0 00.02-5.43c-.12-.93-.34-1.82-.66-2.67a8.9 8.9 0 00-1.32-2.32 6.59 6.59 0 00-2.15-1.75 7.32 7.32 0 00-2.63-.76 27.21 27.21 0 00-3.09-.18h-5.65v20.94z",
    fill: "url(#_Linear13)",
    fillRule: "nonzero",
    transform: "rotate(-15.85 324.76 449.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.78 431.85c0-.88-.12-1.7-.37-2.48a5.8 5.8 0 00-1.07-2.01 5.13 5.13 0 00-1.79-1.36 5.75 5.75 0 00-2.46-.5 5.47 5.47 0 00-4.24 1.9c-.5.59-.9 1.26-1.2 2.02-.3.76-.5 1.57-.59 2.43h11.72zm-11.72 1.73c0 .97.13 1.89.38 2.76.26.86.63 1.61 1.13 2.25a5.47 5.47 0 004.52 2.1c1.37 0 2.53-.36 3.5-1.08a5.17 5.17 0 001.95-3.05h2.32c-.26.86-.6 1.65-1 2.38a6.74 6.74 0 01-3.78 3.17c-.86.3-1.86.45-2.99.45a8.7 8.7 0 01-3.7-.73 7 7 0 01-2.57-2 8.4 8.4 0 01-1.5-2.97 13.5 13.5 0 01.1-7.4 9.46 9.46 0 011.62-3.04 7.58 7.58 0 016.05-2.79c2.48 0 4.42.85 5.83 2.55 1.4 1.7 2.1 4.17 2.08 7.4h-13.94z",
    fill: "url(#_Linear14)",
    fillRule: "nonzero",
    transform: "rotate(-22.61 349.28 442.07)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.24 428.78c.32 1.55.9 2.64 1.75 3.28.84.63 2.05.95 3.62.95.76 0 1.42-.1 1.98-.28a3.97 3.97 0 001.37-.74c.36-.31.63-.67.81-1.06.19-.4.28-.8.28-1.25 0-.88-.28-1.53-.85-1.96a6.44 6.44 0 00-2.13-1c-.86-.24-1.78-.45-2.77-.63-1-.17-1.92-.43-2.78-.77a5.56 5.56 0 01-2.13-1.5 4.03 4.03 0 01-.85-2.73c0-1.5.55-2.74 1.65-3.7 1.1-.96 2.65-1.44 4.66-1.44 1.94 0 3.52.44 4.73 1.3 1.22.87 1.95 2.32 2.2 4.36h-2.11c-.19-1.4-.71-2.37-1.58-2.93a5.87 5.87 0 00-3.27-.85c-1.32 0-2.33.28-3.02.85a2.75 2.75 0 00-1.04 2.23c0 .81.28 1.43.85 1.86.56.42 1.27.77 2.13 1.04.86.26 1.78.5 2.77.7 1 .22 1.92.51 2.78.9.85.37 1.56.89 2.13 1.53.56.65.85 1.55.85 2.7a4.56 4.56 0 01-2.08 3.93c-.65.44-1.42.76-2.3.98-.9.22-1.87.33-2.94.33-1.06 0-2-.15-2.82-.46a6.13 6.13 0 01-3.45-3.25 6.85 6.85 0 01-.56-2.39h2.12z",
    fill: "url(#_Linear15)",
    fillRule: "nonzero",
    transform: "rotate(-28.9 367.53 434.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.81 425.62v-17.96h2.08v17.96h-2.07zm-.1-21.88v-3.08H388v3.08h-2.29z",
    fill: "url(#_Linear16)",
    fillRule: "nonzero",
    transform: "rotate(-33.49 383 425.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.4 412.39c0-1.09-.14-2.1-.4-3.03a7.4 7.4 0 00-1.17-2.43 5.48 5.48 0 00-4.5-2.2c-.88 0-1.7.15-2.43.47-.74.3-1.39.76-1.94 1.37-.56.6-1 1.33-1.3 2.2a8.83 8.83 0 00-.47 3 11.7 11.7 0 00.28 3.17c.23.98.6 1.84 1.1 2.58.51.74 1.16 1.32 1.95 1.75a5.8 5.8 0 002.8.64c.95 0 1.8-.2 2.55-.6.75-.4 1.39-.95 1.9-1.63.53-.69.93-1.48 1.2-2.4.28-.9.42-1.87.42-2.89zm0-9.05h2.07v16.23c0 1.2-.12 2.35-.36 3.45a7.42 7.42 0 01-1.3 2.89 6.51 6.51 0 01-2.57 2c-1.08.5-2.48.74-4.2.74-1.31 0-2.44-.17-3.39-.5a7.37 7.37 0 01-2.32-1.27 5.45 5.45 0 01-1.37-1.68 4.22 4.22 0 01-.5-1.72h2.21a3.8 3.8 0 002 2.65c.47.25 1 .42 1.57.5.58.1 1.18.15 1.8.15 1.42 0 2.55-.25 3.4-.73a4.97 4.97 0 001.95-1.9c.44-.8.72-1.68.85-2.68.12-1 .17-2 .15-3.05a6.44 6.44 0 01-2.75 2.52 8.28 8.28 0 01-3.66.85 7.28 7.28 0 01-6.05-2.86 8.95 8.95 0 01-1.48-3.04 14.67 14.67 0 01-.03-7.31c.3-1.16.78-2.16 1.44-3 .66-.84 1.5-1.51 2.51-2a8.56 8.56 0 015.48-.48c.6.16 1.18.4 1.75.7a6.78 6.78 0 012.72 2.7h.07v-3.16z",
    fill: "url(#_Linear17)",
    fillRule: "nonzero",
    transform: "rotate(-38.82 390.03 421.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.4 407.62h-2.07v-17.96h2.08v2.5c.83-.88 1.69-1.6 2.58-2.15a5.94 5.94 0 013.2-.83c1.12 0 2.14.19 3.1.57a5.27 5.27 0 013.16 3.99c.08.68.12 1.39.12 2.13v11.75h-2.08V395.9c0-1.61-.35-2.83-1.07-3.64-.72-.8-1.9-1.2-3.57-1.2a5.05 5.05 0 00-3.2 1.07 5.24 5.24 0 00-1.8 2.42c-.2.58-.33 1.13-.38 1.67a20.2 20.2 0 00-.06 1.73v9.67z",
    fill: "url(#_Linear18)",
    fillRule: "nonzero",
    transform: "rotate(-46.67 406.83 407.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6 268.82c-9.92 17.3-25.8 70.2-25.8 70.2",
    fill: "none"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-52.67 309.4 -268.09) scale(53.1635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(53.1635) rotate(-43 8.08 -7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(53.1635) rotate(-37.25 9.94 -8.69)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-31.77 644.99 -584.7) scale(53.1635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(53.1635) rotate(-26.29 15.27 -14.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear7",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-21.86 997.54 -963.87) scale(53.1635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(53.1635) rotate(-18.45 22.62 -22.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear9",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-13.13 1709.46 -1781.77) scale(53.1635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear10",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-10.04 2240.57 -2412.22) scale(53.1635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear11",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-8.6 2613.95 -2863.14) scale(53.16355)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear12",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-2.36 9400.9 -11160.75) scale(53.16353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear13",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(53.1635) rotate(6.86 -57.79 78.55)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear14",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(13.62 -1455.37 2216.34) scale(53.1635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear15",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(19.9 -926.79 1580.9) scale(53.1635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear16",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(24.49 -701.68 1315.3) scale(53.1635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear17",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(53.1635) rotate(29.82 -10.06 20.91)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear18",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(37.68 -361 904.63) scale(53.1635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
};
export { SvgLogo as ReactComponent };
export default __webpack_public_path__ + "static/logo.02cde124.svg";